import React, { useCallback } from 'react';

import { Stack, Text } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';

import { BulkCreateIssueCard } from './BulkCreateIssueCard';
import { useAiBulkNavigationGotoPage } from './AiBulkNavigationContextProvider';
import { useBulkCreateContext } from './BulkCreateContextProvider';

// Used for both AI and non-AI bulk create
export const BulkCreateBody = () => {
	const goToPage = useAiBulkNavigationGotoPage();
	// Will have to get the current site that has either been set by default or by the user
	const site = 'current jira site name';
	// Will have to check if bulk create endpoint has been called and is loading
	const project = 'current jira project name';

	const onConfigureClick = useCallback(() => void goToPage('configure'), [goToPage]);
	const [{ aiBulkIssuesList }] = useBulkCreateContext();

	return (
		<Stack>
			<Stack space="space.200">
				<Text size="large">{`Site: ${site}`}</Text>
				<Text size="large">{`Project: ${project}`}</Text>
				<Button
					appearance="subtle"
					testId="bulk-create-configure-button"
					onClick={onConfigureClick}
				>
					Configure
				</Button>
			</Stack>
			<Stack space="space.100">
				{/* We will want to use a different key, this is just to show the rendering of the cards */}
				{aiBulkIssuesList.map((issue) => (
					<BulkCreateIssueCard key={issue.id} issue={issue} />
				))}
			</Stack>
		</Stack>
	);
};
